import jsPDF from "jspdf";
import "jspdf-autotable";

export const exportToPDFClients = (filteredData) => {
  const doc = new jsPDF();
  let yPos = 15;

  filteredData.forEach((client, index) => {
    if (yPos > 250) {
      doc.addPage();
      yPos = 15;
    }

    doc.setFontSize(14);
    doc.text(`Client: ${client.name}`, 14, yPos);
    yPos += 10;

    doc.setFontSize(10);
    doc.autoTable({
      head: [["Email", "Phone", "Address", "Created Date"]],
      body: [
        [
          client.email,
          client.phone,
          client.address || "N/A",
          new Date(client.created_at).toLocaleDateString(),
        ],
      ],
      startY: yPos,
      theme: "grid",
      styles: { fontSize: 8 },
      headStyles: { fillColor: [66, 139, 202] },
    });
    yPos = doc.lastAutoTable.finalY + 10;

    client.locations?.forEach((location) => {
      doc.setFontSize(12);
      doc.text(`Location: ${location.name}`, 14, yPos);
      yPos += 10;

      const buildingsData = location.buildings?.map((building) => [
        building.name,
        `${building.floors} floors`,
        building.elevators
          ?.map(
            (e) => `Elevator ${e.identifier} (${e.capacity}kg, ${e.status})`
          )
          .join("\n"),
      ]);

      if (buildingsData?.length) {
        doc.autoTable({
          head: [["Building", "Floors", "Elevators"]],
          body: buildingsData,
          startY: yPos,
          theme: "grid",
          styles: { fontSize: 8 },
          headStyles: { fillColor: [100, 149, 237] },
        });
        yPos = doc.lastAutoTable.finalY + 10;
      }
    });

    if (index < filteredData.length - 1) {
      doc.setDrawColor(200);
      doc.line(14, yPos, 196, yPos);
      yPos += 10;
    }
  });

  doc.save("detailed_clients_report.pdf");
};
